import React from 'react';

import { Box, AlertTriangleFillIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

const TOOLTIP_TITLE = (
  <>
    This revision has been marked as <strong>Disabled</strong>
  </>
);

// Flex container so the icon centers in the row instead of riding the text baseline
// (WithTooltip's default span container is inline).
const CONTAINER_PROPS = {
  display: 'flex',
  alignItems: 'center',
};

export default function DisabledRevisionWarning() {
  return (
    <WithTooltip
      show
      title={TOOLTIP_TITLE}
      dataTestId="disabledRevisionWarning"
      Container={Box}
      ContainerProps={CONTAINER_PROPS}
    >
      <AlertTriangleFillIcon fontSize="small" color="warning" />
    </WithTooltip>
  );
}
